import delfosImg from '../Logo/logo.png'


const Logo = () => {

    return (

    <div>
    <img src={delfosImg} alt= 'delfosImg' className="logo"/>
        
    </div>

    )
}

export default Logo